import React, { useState, useEffect } from "react";
import axios from 'axios';
import { decode } from 'base64-arraybuffer'; 
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Container,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  ButtonDropdown,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Label,
  Badge,
  Card,
  CardTitle,
  CardBody,
  options
} from "reactstrap";
import Select from "react-select";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import mock from "../tables/mock";
import Widget from "../../components/Widget/Widget.js";
import s from "../tables/Tables.module.scss";
import moreIcon from "../../assets/tables/moreIcon.svg";
import Starrating from "../../assets/tables/Start.png";
import { useHistory, Link } from 'react-router-dom';

import { css } from "@emotion/react";
import { ClockLoader } from "react-spinners";
import "../dashboard/Dashboard.css"
import Clickbutton from "../../assets/info.png"
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Input, Form, Button, CustomInput } from 'reactstrap';
import "../dashboard/Dashboard.css";
import GoogleMap from "../../pages/uielements/maps/google/GoogleMapPage";
import Gmap from "../../assets/map.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import BaseAPI from '../../api/apiurl.js';
import SearchIcon from "../../components/Icons/HeaderIcons/SearchBarIcon.js"
import { format } from 'date-fns';
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import StarRatings from 'react-star-ratings';
import serviceimg from "../../assets/serviceimg.gif"
import './datepicker.css'

import defaultimage from "../../assets/default.jpeg"

const Service = function ({ isOpen, toggle ,}) {
  const [selectedDate, setSelectedDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();
  const [ids, setIds] = useState([]);
  const [formData, setFormData] = useState({
    register: '',
    assignedStaff: '',
    totalHours: '',
    map: '',
    zone: '',
    completed: '',
    completedRemark: '',
    reopen: '',
    reopenRemark: '',
    startRating: '',
  });
  const [rating, setRating] = useState(0); // Initialize with 0 stars


  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChange2 = (date) => {
    setEndDate(date);
  };

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const openModalWithId = (itemId) => {
    fetchDataModel(itemId);
    setIsModalOpen(true);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const closeRejectModal = () => {
    setIsModalOpen(false);
  };

  const openMap = () => {
    setMapVisible(true);
  };

  const closeMap = () => {
    setMapVisible(false);
  }



  const options = [
    { value: '1', label: 'Registered' },
    { value: '2', label: 'Assigned' },
    { value: '3', label: 'Planned' },
    { value: '4', label: 'In-Progress' },
    { value: '5', label: 'Resolved' },
    { value: '6', label: 'Closed' },
    { value: '7', label: 'Re-Open' },
  ]

  const buttonStyle = {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
  };

  const [firstTable] = useState(mock.firstTable);
  const [secondTable] = useState(mock.secondTable);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0); //
  const [tableDropdownOpen, setTableMenuOpen] = useState(false); //
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [mapVisible, setMapVisible] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [clickedImage, setClickedImage] = useState("");
  const [serviceNo, setServiceNo] = useState("");
  const [searchQuery, setSearchQuery] = useState('');
  const [servicestatus, setServicestatus] = useState('');
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [closedModelOpen, setClosedModelOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedreg, setSelectedreg] = useState(null);
  const [closedRegOpen, setClosedRegOpen] = useState(false);
  const [feedback, setFeedback] = useState('');

  const [sortOrder, setSortOrder] = useState('asc'); // or 'desc' for descending order
  const [sortedData, setSortedData] = useState([...data]);

  const [projectname, setProject] = useState([]); // project droupdown
  const [selectedproject, setSelectedproject] = useState(null);
  const [location, setLocation] = useState([]); // location droupdown
  const [selectedlocation, setSelectedlocation] = useState(null);
  const [area, setArea] = useState([]); // Area droupdown
  const [selectedarea, setSelectedArea] = useState(null);
  const [locationKey, setlocationKey] = useState(0);
  const [AreaKey, setAreaKey] = useState(0);


  const pageSize = 10;
const secondTablePagesCount = Math.ceil((data && data.length) ? data.length / pageSize : 0);

  const PaginationComponent = () => {
    const pagesToShow = 5;

    const startPage = Math.max(0, secondTableCurrentPage - Math.floor(pagesToShow / 2));
    const endPage = Math.min(secondTablePagesCount - 1, startPage + pagesToShow - 1);

    return (
      <Pagination className="pagination-with-border">
        <PaginationItem disabled={secondTableCurrentPage <= 0}>
          <PaginationLink
            onClick={(e) => setSecondTablePage(e, secondTableCurrentPage - 1)}
            previous
            href="#top"
          />
        </PaginationItem>
        {[...Array(endPage - startPage + 1)].map((_, i) => (
          <PaginationItem
            key={i}
            active={startPage + i === secondTableCurrentPage}
          >
            <PaginationLink onClick={(e) => setSecondTablePage(e, startPage + i)} href="#top">
              {startPage + i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={secondTableCurrentPage >= secondTablePagesCount - 1}>
          <PaginationLink
            onClick={(e) => setSecondTablePage(e, secondTableCurrentPage + 1)}
            next
            href="#top"
          />
        </PaginationItem>
      </Pagination>
    );
  };


 

  const handleClickserviceAdd = () => {
    history.push('/timeinlive/serviceAdd');
  };



  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  }

  const tableMenuOpen = () => {
    setTableMenuOpen(!tableDropdownOpen);
  } 

  
  const handleImageClick = (imageUrl) => {
    const decodedImage = imageUrl ? imageUrl : defaultimage;
    setClickedImage(decodedImage);
    setIsImageModalOpen(true);
};


  const toggleImageModal = () => {
    setIsImageModalOpen(!isImageModalOpen);
  };

  //meniSearch
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleStatus = (options) => {
    setServicestatus(options.value);
  };

  const openMapModal = () => {
    setMapModalOpen(true);
  };

  const closeMapModal = () => {
    setMapModalOpen(false);
  };


  const closedModalWithId = (itemId) => {
    setSelectedItemId(itemId);
    setClosedModelOpen(true);
  };

  const closedModalClosed = () => {
    setClosedModelOpen(false);
  };

  const Rigwithid = (itemId) => {
    setSelectedreg(itemId);
    setClosedRegOpen(true);
  };

  const closedRegClosed = () => {
    setClosedRegOpen(false);
  };


  const filteredData = data.filter((item) => {
    // You can customize the condition based on your requirements
    return item.servicerefno.includes(searchQuery);
  });

  const sortByPriority = () => {
    const sorted = [...data].sort((a, b) => {
      // Assuming priority is a string like "p1", "p2", "p3"
      if (sortOrder === 'asc') {
        return a.priority.localeCompare(b.priority);
      } else {
        return b.priority.localeCompare(a.priority);
      }
    });

    setSortedData(sorted);
  };

  const toggleSortOrder = () => {
    setSortOrder(prevSortOrder => (prevSortOrder === 'asc' ? 'desc' : 'asc'));
  };


  const fetchDataModel = async (itemId) => {

    console.log("Received itemId inside fetchDataModel:", itemId);
    try {
      // Make an API request to fetch data
      const response = await axios.get(`${BaseAPI}servicecard/${itemId}`);
      console.log("varrrruuutha ", itemId);
      // Extract data from the API response
      const serviceData = response.data.data[0].service;

      // Populate the formData state with the extracted data
      setFormData({
        register: serviceData.regdate,
        staff: serviceData.name,
        totalHours: serviceData.hours, // You need to set this field based on your data
        map: serviceData.serviceremarks, // You need to set this field based on your data
        zone: serviceData.created_date, // You need to set this field based on your data
        completed: serviceData.servicecompdate, //=== 1 ? 'Yes' : 'No', // Example condition
        completedRemark: serviceData.servicefdbkremarks,
        reopen: serviceData.status, // You need to set this field based on your data
        reopenRemark: serviceData.serviceremarks, // You need to set this field based on your data
        assigned: serviceData.asndate,
      });

      localStorage.setItem('servicereglng', serviceData.servicereglat);
      localStorage.setItem('servicereglat', serviceData.servicereglng);

    } catch (error) {
      console.error('Error fetching data from API:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    setFormData({
      ...formData,
      [name]: newValue,
    });
  };

  const fetchData = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');
    const role = localStorage.getItem('role');
    const Id = localStorage.getItem('id');



    const isRoleTwo = role === '2';
  

    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }

    const url = `${BaseAPI}servicelistview`;
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: customerId, company_id: companyId ,role_id: role, id: Id })
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((actualData) => {
        console.log(actualData);

        if (actualData.data && actualData.data.length > 0) {
          setData(actualData.data);
        } else {
          setData([]); // Set an empty array if there's no data
        }
        console.log("actualData", actualData);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleSearch = () => {
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');

    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }

    const formattstartdate = selectedDate ? format(selectedDate, 'dd-MM-yyyy') : '';
    const formatenddate = endDate ? format(endDate, 'dd-MM-yyyy') : '';
    const locationValue = selectedlocation ? selectedlocation.value : '';
    const productSelectid = selectedproject ? selectedproject.value || '' : '';
    const areaValue = selectedarea ? selectedarea.label : '';
    // const servicestatusString = servicestatus.map(option => option.value).join(',');

    const url = `${BaseAPI}servicefilters?company_id=${companyId}&customer_id=${customerId}&service_no=${serviceNo}&servicestatus=${servicestatus}&start_date=${formattstartdate}&end_date=${formatenddate}&productselect=${productSelectid}&location=${locationValue || ''}&area=${areaValue || ''}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.data && data.data.length > 0) {
          setData(data.data);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching data from API:', error);
      });
  };

  const handleCancel = () => {
    fetchData();
    setServiceNo('');
    setSelectedDate(null);
    setEndDate(null);
    setServicestatus('');
    setSelectedproject(null);
    setSelectedlocation(null);
    setSelectedArea(null);
    
  };

  const handelclosedservice = () => {
    // Send a POST request to update service feedback
    const customerId = localStorage.getItem('customerid');
    const companyId = localStorage.getItem('companyid');
    const itemId = selectedItemId;

    if (!customerId || !companyId) {
      console.log('Missing customer ID or company ID.');
      return;
    }
    const servicestatus = 6;

    const apiUrl = `${BaseAPI}serviceactionview/${itemId}?company_id=${customerId}&customer_id=${companyId}&servicestatus=${servicestatus}&feedbackrating=${rating}&servicefeedback=${feedback}`;

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        servicefeedback: feedback,
      }),
    })
      .then((response) => {
        if (response.ok) {
          // Handle a successful response here
          console.log('Service feedback updated successfully');
          fetchData();
          setClosedModelOpen(false);

        } else {
          // Handle errors here
          console.error('Failed to update service feedback');
        }
      })
      .catch((error) => {
        // Handle network errors here
        console.error('Network error:', error);
      });
  };

  const stickyStyle = {
    position: 'sticky',
    top: 0,
    backgroundColor: '#fff'
  };

  const handleServiceCancel = ( ) => {
    const customer_id = localStorage.getItem('customerid'); 
    const company_id = localStorage.getItem('companyid');
    const itemId = selectedreg; 
    
    fetch(`${BaseAPI}servicecancel/${itemId}?company_id=${company_id}&customer_id=${customer_id}&servicestatus=-1`, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
       
      },
      
    })
    .then(response => {
      if (response.ok) {
        // Handle a successful response here
     
        fetchData();
        setClosedRegOpen(false);

      } else {
        // Handle errors here
        console.error('Failed to Service Cancel');
      }
    })
    .catch(error => {
      // Handle errors, perhaps show an error message
    });
  };


const fetchproduct = async () => {
  try {
      const url = `${BaseAPI}serviceproduct`;
      const companyId = localStorage.getItem('companyid');
      const customerId = localStorage.getItem('customerid');
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              // You might need to add other headers if required (e.g., authorization headers)
          },
          body: JSON.stringify({
              company_id: companyId,
              customer_id: customerId
          }),
      });

      if (!response.ok) {
          throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      setProject(data.data.map(item => ({ label: item.productname, value: item.id })));
  } catch (error) {
      console.error('Error:', error);
      // Handle the error here if needed
  }
};


const fetchloaction = async (productId) => {
try {
    const url = `${BaseAPI}productlocationdrop`;
    const companyId = localStorage.getItem('companyid');
    const customerId = localStorage.getItem('customerid');
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
            company_id: companyId,
            customer_id: customerId,
            product_id : productId,
        }),
    });

    if (!response.ok) {
        throw new Error('Network response was not ok.');
    }

    const data = await response.json();
    setLocation(data.data.map(item => ({  label: item.AssignDesc, value: item.id })));
} catch (error) {
    console.error('Error:', error);
    // Handle the error here if needed
}
};

const fetchArea = async (locationId) => {
try {
    const url = `${BaseAPI}productareadrop`;
    const companyId = localStorage.getItem('companyid');
    const customerId = localStorage.getItem('customerid');
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            // You might need to add other headers if required (e.g., authorization headers)
        },
        body: JSON.stringify({
            company_id: companyId,
            customer_id: customerId,
            location_id: locationId,
        }),
    });

    if (!response.ok) {
        throw new Error('Network response was not ok.');
    }

    const data = await response.json();
    setArea(data.data.map(item => ({ label: item.area, value: item.id })));
} catch (error) {
    console.error('Error:', error);
    // Handle the error here if needed
}
};


const handleProlectChange = async (newValue) => {
setSelectedproject(newValue);

try {
  const productId = newValue && typeof newValue === 'object' ? newValue.value : null;

  if (productId) {
    
    setLocation([]);
    setSelectedlocation(null);
    setArea([]);
    setSelectedArea(null);
    setAreaKey(prevKey => prevKey + 1);
    setlocationKey(prevKey => prevKey + 1);

    
    await fetchloaction(productId);
  } else {
    console.error('Invalid or missing project ID');
  }
} catch (error) {
  console.error('Error fetching tasks:', error);
  // Handle errors if needed
}
};


const handleLocationChange = async (value) => {
try {
  setSelectedlocation(value);

  console.log('Selected Location:', value); // Log the entire value for debugging

  const locationId = value && typeof value === 'object' ? value.value : null;
  console.log('Location ID:', locationId); // Log the locationId for debugging


  if (locationId) {
    setArea([]);
    setSelectedArea(null);
   
    setAreaKey(prevKey => prevKey + 1);

    
    await fetchArea(locationId);
  } 
  
  
  else {
    console.error('Invalid or missing location ID');
  }
} catch (error) {
  console.error('Error fetching areas:', error);
  // Handle errors if needed
}
};



  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    fetchData();
    return () => clearTimeout(loadingTimeout), fetchData() , fetchproduct();

  }, []);

  useEffect(() => {
    if (ids.length > 0) { // Check if there are any IDs in the ids array
      fetchDataModel(ids[0]); // Pass the first ID from the ids array
    }
  }, [ids]);

  useEffect(() => {
    sortByPriority();
  }, [data, sortOrder]);

  const stickyStyles = {
    position: '-webkit-sticky',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    backgroundColor: "#fff"
    /* Other styles */
  };

  const combinedData = searchQuery ? filteredData : sortedData;


  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <ClockLoader color={"#4e73df"} loading={isLoading} css={spinnerStyle} size={100} />
        </div>
      ) : (
        <Container fluid style={{ overflow: 'auto'}}>
          <br></br>
            
            <Row >
              <Col>
                <Row className="mb-4">
                  <Col>
                    <Widget>
                      <div style={{ padding: "20px" }}>
                         <div className="headline-2" style={{color : "blue"}}>Service
                          <div style={{ float: "right" }}>
                            <button type="button" className="btn btn-primary" onClick={handleClickserviceAdd}>Add</button> &nbsp;
                            <button type="button" className="btn btn-primary" onClick={handleSearch}>
                              <FontAwesomeIcon icon={faSearch} style={{ marginRight: '5px' }} />
                              Search
                            </button> &nbsp;
                            <button type="button" className="btn btn-primary" onClick={handleCancel}>
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ whiteSpace: 'nowrap' }}>
                        <div className="col-sm-3">

                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required ">Service No</label>
                          <div style={{ marginLeft: "3px", padding: "10px" }}>
                            <input
                              type="text"
                              className="form-control"
                              id="inputPassword"
                              placeholder="Enter the complaint no"
                              required
                              value={serviceNo}
                              onChange={(e) => setServiceNo(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Product Select</label>
                          <div style={{ marginLeft: "3px", padding: "10px" }}>
                          <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose Product..."
                                        title="Asset Form"
                                        options={projectname}
                                        value={selectedproject}
                                        onChange={handleProlectChange}
                                    />
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Product Location</label>
                          <div style={{ marginLeft: "3px", padding: "10px" }}>
                          <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose Location..."
                                        title="Asset Form"
                                        options={location}
                                        value={selectedlocation}
                                        onChange={handleLocationChange}
                                        key={locationKey}
                                    />
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Product Area</label>
                          <div style={{ marginLeft: "3px", padding: "10px" }}>
                          <Select
                                        classNamePrefix="select2-selection"
                                        placeholder="Choose Area..."
                                        title="Asset Form"
                                        options={area}
                                        value={selectedarea}
                                        onChange={setSelectedArea}
                                        key={AreaKey}
                                    />
                          </div>
                        </div>
                       
                        <div className="col-sm-3">
                          <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Status Select</label>
                          <div style={{ marginLeft: "3px", padding: "10px" }}>
                            <Select
                              classNamePrefix="select2-selection"
                              placeholder="Choose..."
                              title="Asset Form"
                              options={options}
                              onChange={handleStatus}
                              value={options.find(option => option.value === servicestatus) || ''} 
                            // isMulti={true} 
                            />
                          </div>
                        </div>
                        <div className="col-sm-3">
      <label htmlFor="assetCode" className="col-sm-3 col-form-label label-required">Register From Date</label>
      <div className="input-group" style={{ padding: "10px" }}>
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select a date"
          className=" form-control custom-datepicker"
          wrapperClassName="custom-datepicker-wrapper"
        />
      </div>
    </div>


                        <div className="col-sm-3">

                          <label htmlFor="assetCode" className="col-sm-4 col-form-label label-required">Register To Date</label>
                          <div className="row-sm-3" style={{ marginRight: '5px', padding: "10px" }}>
                            <DatePicker
                              type="text"
                              className=" form-control custom-datepicker"
                              wrapperClassName="custom-datepicker-wrapper"
                              selected={endDate} // Replace with your state variable for the selected date
                              onChange={handleDateChange2}
                              dateFormat="dd/MM/yyyy"
                              placeholderText="Select a date"
                            />
                          </div>

                        </div>
                      </div>



                    </Widget>
                  </Col>
                </Row>
              </Col>
            </Row>
         
          
          <div>

            <Row>
              <Col>
                <Row className="mb-4">
                  <Col>
                    <Widget>
                      <div style={{ padding: "20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center", whiteSpace: 'nowrap' }}>
                           <div className="headline-2" style={{color : "blue"}}>Service Details </div> &nbsp; &nbsp;
                          <label htmlFor="searchUser" className="sr-only">
                            Search User
                          </label>

                        </div>
                      </div>


                      <div className="widget-table-overflow">
                        {data && data.length > 0 ? (
                          <div style={{
                            maxHeight: '500px',
                            overflowY: 'auto',
                          }} >

                            <Table className={`table-striped table-borderless table-hover`} responsive  style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ whiteSpace: 'nowrap' , width: '100%'}}>
                                  <th>
                                    Details
                                  </th>
                                  <th>Image</th>
                                  <th>Service No</th>
                                  <th>Status</th>
                                  <th>Request Description</th>
                                  <th onClick={toggleSortOrder}>
                                    Priority {sortOrder === 'asc' ? '▲' : '▼'}
                                  </th>
                                  <th>Product</th>
                                  {/* <th>Feedback Rating</th> */}
                                  <th>Register</th>
                                  <th>Desired</th>
                                  <th>Completed</th>  
                                  

                                </tr>
                              </thead>
                              <tbody style={{ whiteSpace: 'nowrap', textAlign: "center", height: "10px" }}>
                                {combinedData
                                  .slice(secondTableCurrentPage * pageSize, (secondTableCurrentPage + 1) * pageSize)
                                  .map((item, index) => {

                                    const startRating = item.servicefdbkrating;

                                    return (
                                      
                                      <tr key={index}  style={{ whiteSpace: 'nowrap' , width: '100%'}}  >
                                        {/* {console.log("item.service.id:", item.service.id) } */}
                                        <td className='zoom-in-sicon'>
                                        <img
  src={Clickbutton}
  alt="Click Button"
  type="button"
  width="40"
  height="40"
  style={{ zIndex: "2" }}
  onClick={() => openModalWithId(item.id)}
/>

                                        </td>
                                        <td>
  <img
   src={item.serviceimg ? `data:image/png;base64,${item.serviceimg}` : defaultimage}
   alt="No Image"
   style={{ maxWidth: "50px", maxHeight: "40px"}}
   className="zoom-in-Qr"
   onClick={() => handleImageClick(item.serviceimg ? `data:image/png;base64,${item.serviceimg}` : defaultimage)}
  />
</td>
                                        <td>{item.servicerefno}</td>
                                        <td><Badge style={{
                                          backgroundColor:
                                            item.status === 'Registered' ? 'blue' :
                                              item.status === 'Assigned' ? 'deepskyblue' :
                                                item.status === 'Planned' ? 'brown' :
                                                  item.status === 'In-Progress' ? 'indigo' :
                                                    item.status === 'Resolved' ? 'transparent' :
                                                      item.status === 'Closed' ? 'Green' :
                                                        item.status === 'Re-Open' ? 'Yellow' :
                                                        item.status === 'Cancelled' ? 'gray' : 'black',
                                          color: item.status === 'Re-Open' ? 'black' : 'white',
                                        }}
                                        onClick={
                                          item.status === 'Registered' ? () => Rigwithid(item.id) :
                                          item.status === 'Planned' ? () => Rigwithid(item.id) :
                                          null
                                        }
                                       

                                        >
                                         
                                          
                                          {item.status !== 'Resolved' ? item.status : (
                                          <button
                                            className="btn btn-primary"
                                            style={{ padding: "5px 10px", fontSize: "12px" }}
                                            onClick={() => closedModalWithId(item.id)}
                                          >
                                            To Close
                                          </button>
                                        )}</Badge></td>
                                        <td style={{ overflow: 'auto' }}>
                                          <textarea
                                            value={item.servicedesc}
                                            rows={1}
                                            cols={20}
                                          />
                                        </td>

                                        <td>{item.priority}</td>
                                        <td>{item.productname}</td>
                                        {/* <td><StarRating rating={startRating} starClass="gold-star" /></td> */}
                                        <td>{item.regdate}</td>
                                        <td>{item.desireddate}</td>
                                        <td>{item.servicecompdate}</td>
                                        

                                        {console.log("Service Image", item.serviceimg)}
                                      </tr>
                                    );
                                  })
                                }
                              </tbody>

                            </Table>
                          </div>

                        ) : (
                          <div colSpan="9" style={{ textAlign: "center", color: "red" }}>No Data Available</div>
                        )}
                        <div style={{ textAlign: "left", marginTop: "20px", whiteSpace: 'nowrap' }}>
                          <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                            Total Service: <span style={{ color: "blue" }}>{data ? data.length : 0}</span>
                          </p>
                        </div>

                        <PaginationComponent />
                      </div>


                    </Widget>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
      )}
      <Modal isOpen={isModalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Service Details</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <Form>
                <FormGroup>
                  <Label for="register">Register</Label>
                  <Input
                    type="text"
                    name="register"
                    id="register"
                    value={formData.register}
                    onChange={handleChange}
                    disabled
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="assignedStaff">User</Label>
                  <Input
                    type="text"
                    name="assignedStaff"
                    id="assignedStaff"
                    value={formData.staff}
                    onChange={handleChange}
                    disabled
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="assignedStaff">Assigned</Label>
                  <Input
                    type="text"
                    name="assignedStaff"
                    id="assignedStaff"
                    value={formData.assigned}
                    onChange={handleChange}
                    disabled
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="totalHours">Total Hours</Label>
                  <Input
                    type="text"
                    name="totalHours"
                    id="totalHours"
                    value={formData.totalHours}
                    onChange={handleChange}
                    disabled
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="map">Map</Label>
                  &nbsp;  &nbsp;  &nbsp;
                  <img src={Gmap} alt="edit" style={{ width: '30px', height: '30px' }} type="button" className='zoom-in-icone' onClick={openMapModal} />

                </FormGroup>
              </Form>
            </div>
            <div className="col-md-6">
              <Form>

                <FormGroup>
                  <Label for="completed">Completed</Label>
                  <Input
                    type="text"
                    name="completed"
                    id="completed"
                    value={formData.completed}
                    onChange={handleChange}
                    disabled
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="completedRemark">Completed Remark</Label>
                  <Input
                    type="textarea"
                    name="completedRemark"
                    id="completedRemark"
                    value={formData.completedRemark}
                    onChange={handleChange}
                    disabled
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="reopen">Reopen</Label>
                  <Input
                    type="text"
                    name="reopen"
                    id="reopen"
                    value={formData.reopen}
                    onChange={handleChange}
                    disabled
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="reopenRemark">Reopen Remarks</Label>
                  <Input
                    type="textarea"
                    name="reopenRemark"
                    id="reopenRemark"
                    value={formData.reopenRemark}
                    onChange={handleChange}
                    disabled
                  />
                </FormGroup>
              </Form>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={closeRejectModal}>
            OK
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={isImageModalOpen} toggle={toggleImageModal}>
  <ModalHeader toggle={toggleImageModal}>Image Preview</ModalHeader>
  <ModalBody>
    {clickedImage ? (
      <img
        src={clickedImage}
        alt="View Image"
        style={{ maxWidth: "100%" }}
      />
    ) : (
      <p>No image to display</p>
    )}
    <script>
      alert(clickedImage);
    </script>
  </ModalBody>
  <ModalFooter>
    <button className="btn btn-primary" onClick={toggleImageModal}>
      Close
    </button>
  </ModalFooter>
</Modal>

      <Modal isOpen={mapModalOpen} toggle={closeMapModal}>
        <ModalHeader toggle={closeMapModal}>Google Map</ModalHeader>
        <ModalBody>
          <GoogleMap /> 
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-danger" onClick={closeMapModal}>
            Close Map
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={closedModelOpen} toggle={closedModalClosed}>
        <ModalHeader toggle={closedModalClosed}>Closed Service</ModalHeader>
        <ModalBody>
          <div>
            <label>Feedback:</label>
            <textarea className="form-control" rows="4"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}></textarea>
          </div>
          &nbsp; &nbsp;
          <div>
            <label>Rating:</label>
            <StarRatings
              rating={rating}
              starRatedColor="blue" // You can customize the color
              changeRating={(newRating) => setRating(newRating)}
              numberOfStars={5} // Number of stars
              name="rating"
            />
          </div>
        </ModalBody>

        <ModalFooter>
          <button className="btn btn-danger" onClick={handelclosedservice}>
            Closed
          </button>
        </ModalFooter>
      </Modal>


      <Modal isOpen={closedRegOpen} toggle={closedRegClosed}>
        <ModalHeader toggle={closedRegClosed}>Cancel Service Confirmation</ModalHeader>
        <ModalBody>
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: "red", fontWeight: "bold" }}>Are you sure you want to Cancel This Service?</p>
            <img
              src={serviceimg} // Replace with the URL of your GIF
              alt="Logout GIF"
              width="30%"
              style={{ display: "block", margin: "0 auto" }}
            />
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <Button color="secondary" onClick={closedRegClosed}>
            Close
          </Button>
          <Button color="danger" onClick={handleServiceCancel}>
           Confirm
          </Button>
        </ModalFooter>
      </Modal>

    </div>


  )
}

const spinnerStyle = css`
display: block;
margin: 0 auto;
`;

export default Service;
